import React from 'react';
import './App.css';
import Profile from './Profile';
import Link from './Link';
import SmartStore from './SmartStore';
import Footer from './Footer';

function App() {
  const links = [
    {
      id: 1,
      url: "https://smartstore.naver.com/tong-is/products/12065165913",
      title: "OPEN 비닐 글라스 퓨어 베일 스틸레토 뮬 (9cm)",
      main_img: "/main_shoe.jpg",
    },
    {
      id: 2,
      url: "https://smartstore.naver.com/tong-is/",
      title: "LACHLO smart store",
      main_img: "/logo512.png",
    }
  ];

  return (
    <div className="App">
      <Profile />
      <div className="links-container">
        {links.map(link => (
          <Link 
            key={link.id}
            id={link.id} 
            url={link.url} 
            title={link.title} 
            mainImg={link.main_img}
          />
        ))}
      </div>
      <SmartStore />
      <Footer />
    </div>
  );
}

export default App;